import {environmentImports} from './environment/environment';
import {elementExists} from '@lib/util/dom';

async function main() {
    if (elementExists('.lazy-loader')) {
        const {createBackgroundImageLoaderListeners} = await import('./lib/backgroundImageLoader');
        createBackgroundImageLoaderListeners(document.querySelectorAll<HTMLElement>('.lazy-loader'));
    }

    await importUtils();
    await import('./vue/bootstrap');

    const {showCookieMessageIfNotAccepted, setCookies} = await import('./lib/cookieMessage');
    showCookieMessageIfNotAccepted();
    setCookies();

    const {showPrivacySettingsModal} = await import('./lib/privacySettingsModal');
    showPrivacySettingsModal();

    if (elementExists( '.js-menu')) {
        const {createMobileNavListeners} = await import('./lib/nav/mobileNav');
        createMobileNavListeners();
    }

    const slides = document.querySelectorAll<HTMLElement>('.glide');
    if (slides.length > 0) {
        const {createSliderListeners} = await import('./lib/slider');
        createSliderListeners();
    }

    if (elementExists('.js-sub-nav-wrapper') ||
        elementExists('.js-expose-prices')
    ) {
        const {createScrollListeners} = await import('./lib/scroll');
        createScrollListeners();
    }

    const {createScrollTargetListener} = await import('./lib/scroll/target'/* webpackChunkName: "scroll-target" */);
    createScrollTargetListener();

    const modals = document.querySelectorAll<HTMLElement>('.js-modal');
    if (modals.length > 0) {
        const {createModalListeners} = await import('./lib/modal'/* webpackChunkName: "modal" */);
        createModalListeners(modals);
    }

    const flyouts = document.querySelectorAll<HTMLElement>('.js-flyout');
    if (flyouts.length > 0) {
        const {createFlyoutListeners} = await import('./lib/flyout'/* webpackChunkName: "flyout" */);
        createFlyoutListeners(flyouts);
    }

    if (elementExists('.js-expose-gallery') || elementExists('.js-cropped-text')) {
        const {createGalleryListeners} = await import('./lib/gallery'/* webpackChunkName: "gallery" */);
        createGalleryListeners();

        const {createTripExposeListener} = await import('./lib/trip'/* webpackChunkName: "trip" */);
        createTripExposeListener();
    }

    if (elementExists('.js-expose-gallery-hero-trigger')) {
        const {createHeroGalleryListeners} = await import('./lib/gallery');
        createHeroGalleryListeners();
    }

    if (elementExists('.js-expose-teaser')) {
        const {createBestOfListeners} = await import('./lib/gallery');
        createBestOfListeners();
    }

    const {Expander} = await import('./lib/expander'/* webpackChunkName: "expander" */);
    Expander.init();

    if (elementExists('[data-expand-cropped]')) {
        const {ExpandToggle} = await import('./lib/expander'/* webpackChunkName: "expander" */);
        ExpandToggle.init();
    }

    const backgroundVideos = <NodeListOf<HTMLVideoElement>>document.querySelectorAll<HTMLElement>('.c-banner--video video');
    if (backgroundVideos.length) {
        const {createVideoBackgroundListener} = await import('./lib/video/background'/* webpackChunkName: "video-background" */);
        createVideoBackgroundListener(backgroundVideos);
    }

    await importLegacy();

    if (elementExists('.js-hide-in-scroll')) {
        const {moveHeaderListener} = await import('./lib/header/header');
        moveHeaderListener();
    }

    if (elementExists('.js-search-container')) {
        const {openHeaderSearch} = await import('./lib/header/header');
        openHeaderSearch();
    }

    if (elementExists('.js-toggle-menu')) {
        const {menuTriggerListener} = await import('./lib/nav/burgerMenu');
        menuTriggerListener();
    }

    if(elementExists('.js-overlay-trigger')) {
        const {createOverlayListener} = await import('./lib/overlay/overlay');
        createOverlayListener();
    }

    if(elementExists('.js-video')) {
        const {createPlayListener, createPauseListener, autoPlay} = await import('./lib/video/exposeBackgroundVideo');
        autoPlay();
        createPlayListener();
        createPauseListener();
    }

    if(elementExists('.js-overlay-contact-trigger')) {
        const {createOverlayContactListener} = await import('./lib/overlay/contactOverlay');
        createOverlayContactListener();
    }

    if(elementExists('.js-finish-datalayer-trigger')) {
      const {createFinishDataLayerEvents} = await import('./lib/dataLayer/index');
      createFinishDataLayerEvents();
    }
}

async function importLegacy() {
    if (elementExists('.js-enquiry-tracking-form')) {
        const {initEnquiryForm} = await import('./unported/enquiryForm'/* webpackChunkName: "enquiry-form" */);
        initEnquiryForm();
    }
}

async function importUtils() {
    const {createEqjsListeners} = await import('./lib/eqjs'/* webpackChunkName: "eqjs" */);
    createEqjsListeners();

    const {createBreakpointListeners} = await import('./lib/util/breakpoint'/* webpackChunkName: "util-breakpoint" */);
    createBreakpointListeners();

    const {createDataLayerListeners} = await import('./lib/dataLayer'/* webpackChunkName: "datalayer" */);
    createDataLayerListeners();
}

Promise.all(environmentImports)
    .then(main);
